import { ReactComponent as LogoIconSVG } from "@app/assets/allgo_dev_footer_icon.svg";
import { Box, Container, Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { RootState } from "@app/redux/store/root";
import useStyles from "./styles";

function Footer(): JSX.Element {
    const classes = useStyles();

    const currentYear = new Date().getFullYear();

    const appstoreVersion = useSelector((state: RootState) => state.appstoreVersion.version);

    return (
        <Box className={classes.root} paddingTop={5.5} paddingBottom={1}>
            <Container maxWidth="md" disableGutters={true}>
                <Grid
                    container
                    alignItems="flex-start"
                    justifyContent="center"
                    className={classes.boxCommonLinks}
                >
                    <Grid item>
                        <Box className={classes.logo}>
                            <LogoIconSVG test-data-id="visteon-footer-icon" width="170" />
                        </Box>
                    </Grid>
                    {/* <Grid item xs={12} md={5}>
                        <Grid container justifyContent="space-between">
                            <Grid item xs={6} md={5}>
                                <Box className={classes.linksBoxClasses}>
                                    <Typography color="textSecondary" variant="subtitle2" className={linksTitleClasses}>Support</Typography>
                                    <Typography variant="body2" className={linksItemsClasses}>
                                        <Link to='/contact'>Contact Us</Link>
                                    </Typography>
                                    <Typography variant="body2" className={linksItemsClasses}>
                                        <Link to='/support'>Raise Support Ticket</Link>
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={6} md={5}>
                                <Box className={classes.linksBoxClasses}>
                                    <Typography variant="subtitle2" className={linksTitleClasses}>Documentation</Typography>
                                    <Typography variant="body2" className={linksItemsClasses}>
                                        <Link to='/api'>API Reference</Link>
                                    </Typography>
                                    <Typography variant="body2" className={linksItemsClasses}>
                                        <Link to='/sdk'>App Store Client SDK</Link>
                                    </Typography>
                                    <Typography variant="body2" className={linksItemsClasses}>
                                        <Link to='/dev-guidelines'>Developer Guidelines</Link>
                                    </Typography>
                                    <Typography variant="body2" className={linksItemsClasses}>
                                        <Link to='/ux-guidelines'>UX Guidelines</Link>
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid> */}
                </Grid>

                <Grid container justifyContent="center">
                    <Grid item>
                        <Box
                            test-data-id="visteon-appstore-version"
                            component="div"
                            color="#000"
                            className={classes.boxCopyright}
                        >
                            {appstoreVersion ? `Appstore version: ${appstoreVersion}` : ""}
                        </Box>
                    </Grid>
                </Grid>

                <Grid container justifyContent="center">
                    {/* <Grid item xs={12} md={6}>
                        <Box display="flex" justifyContent="flex-end" alignContent="center" className={classes.boxPrivacyTermsLinks}>
                            <Typography variant="body2" component="div" className={classes.linksPrivacyAndTerms}>
                                <Link to="/">Privacy Policy</Link>
                            </Typography>
                            <Box mx={5} component="span">|</Box>
                            <Typography variant="body2" component="div" className={classes.linksPrivacyAndTerms}>
                                <Link to="/">Terms of Use</Link>
                            </Typography>
                        </Box>
                    </Grid> */}
                    <Grid item>
                        <Box
                            test-data-id="visteon-copyright-text"
                            component="div"
                            color="#000"
                            className={classes.boxCopyright}
                        >
                            {`\u00A9 ${currentYear}`} Visteon, Inc. All rights reserved.
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}

export default Footer;
